import React from 'react';
import { Box, Link } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { FPSPhoneNumbers } from '../shared/Content';
import { PsBeaconButton, PsBeaconIcon, PsBeaconModal } from '../shared/BeaconRegister';
import GenericError from '../shared/Errors/GenericError';
import { GENERAL_HUB_ERROR_MODAL } from '../../Constants';

const HubGeneralErrorModal = () => {
    const handleRefresh = () => {
        window.location.reload(true);
    };

    return (
        <PsBeaconModal id={GENERAL_HUB_ERROR_MODAL} persist onBeaconEventClose={handleRefresh}>
            <Box>
                <GenericError id="general-hub-error" title="Sorry, something went wrong">
                    <Box sx={{ paddingBottom: '24px' }}>
                        Thanks for your patience. Please try refreshing your page or check back
                        later.
                    </Box>
                    <Box sx={{ paddingBottom: '32px' }}>
                        If the problem continues, call{' '}
                        <Link
                            bold
                            href={`tel:+${FPSPhoneNumbers.serviceErrorNumber}`}>
                            {FPSPhoneNumbers.serviceErrorNumber}
                        </Link>
                        {` `}for technical support. Available weekdays, 8 a.m. to 8 p.m. ET.
                    </Box>
                </GenericError>
            </Box>
            <Box
                slot="action-zone"
                className="fixed"
                id="button-container"
                sx={{ display: 'flex', justifyContent: 'end' }}>
                <PsBeaconButton variant="primary" onClick={handleRefresh} size="normal">
                    <PsBeaconIcon name="reload" slot="prefix" alt="refresh-icon" /> Refresh Page
                </PsBeaconButton>
            </Box>
        </PsBeaconModal>
    );
};

export default function HubGeneralError() {
    return <HubGeneralErrorModal />;
}
